import { createElementFromHTML, loadImage } from './../../js/helper';
import { Overlay } from './../../components/overlay/overlay';
import { sendTracking } from '../../js/tracking';

class ImageZoom {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-imagezoom',
            loader: null
        };

        this.settings = Object.assign({}, defaults, options);

        this.$imageZoom = element;
        this.imageSrc = this.$imageZoom.getAttribute('href');
        this.mimetype = this.$imageZoom.getAttribute('data-mimetype');

        if (this.settings.loader !== null) {
            this.$loader = createElementFromHTML(this.settings.loader);
        }

        if (this.imageSrc) {
            this.initialize();
        }
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$imageZoom.addEventListener('click', (e) => {
            let imageIndex = '';
            if (e.target.getAttribute('data-image-index')) {
                imageIndex = e.target.getAttribute('data-image-index');
            }
            this._buildOverlay(imageIndex);

            e.preventDefault();
        });
    }

    _buildOverlay (imageIndex) {
        this.$imageZoom.classList.add('is--loading');
        if (this.$loader) {
            this.$imageZoom.appendChild(this.$loader);
        }

        const overlay = new Overlay({
            loader: this.settings.loader,
            contentClass: 'image-zoom',
            overlayClass: 'overlay--with-slider'
        });

        if (this.$imageZoom.classList.contains('zoom--with-slider')) {
            const $imageZoomOverlay = this.$imageZoom.closest('.has--zoom-image-overlay').querySelector('.image-zoom-slider-overlay');
            const $imageZoomParent = $imageZoomOverlay.parentNode;
            const $imageZoomCopy = $imageZoomOverlay.cloneNode(true);
            $imageZoomParent.appendChild($imageZoomCopy);

            const handleSlider = (Slider) => {
                let clicked = false;
                this.overlaySlider = new Slider($imageZoomOverlay, {
                    effect: 'fade',
                    breakpoints: null,
                    speed: 500,
                    indicators: true,
                    prevnext: true,
                    slidesPerView: 1,
                    initAttr: 'data-image-overlay-slider',
                    initialSlide: imageIndex,
                    onSlideChange: ($slider, slider, $currentSlide, currentIndex) => {
                        if (this.trackingCategory !== null) {
                            let direction;
                            if (currentIndex > this.currentIndex) {
                                direction = 'forth';
                            } else {
                                direction = 'back';
                            }

                            if (clicked === false) {
                                sendTracking({
                                    category: this.trackingCategory,
                                    action: 'swipe',
                                    label: 'slide_' + direction + '_' + (currentIndex + 1)
                                });
                            }

                            this.currentIndex = currentIndex;
                            clicked = false;
                        }
                    },
                    onClickPrev: (currentIndex) => {
                        clicked = true;

                        if (this.trackingCategory !== null) {
                            sendTracking({
                                category: this.trackingCategory,
                                action: 'click',
                                label: 'btn_back_' + (currentIndex + 1)
                            });
                        }
                    },
                    onClickNext: (currentIndex) => {
                        clicked = true;

                        if (this.trackingCategory !== null) {
                            sendTracking({
                                category: this.trackingCategory,
                                action: 'click',
                                label: 'btn_forth_' + (currentIndex + 1)
                            });
                        }
                    }
                });
            };

            import('../../components/slider/slider').then(({ Slider }) => {
                handleSlider(Slider);
            });

            setTimeout(() => {
                const $swiperPagination = $imageZoomOverlay.querySelector('.swiper-pagination');
                if ($swiperPagination) {
                    $swiperPagination.remove();
                }
            }, 100);

            overlay.setContent($imageZoomOverlay);
            overlay.show();

            this.$imageZoom.classList.remove('is--loading');
            if (this.$loader) {
                this.$loader.parentNode.removeChild(this.$loader);
            }
        } else {
            const $image = document.createElement('img');
            $image.src = this.imageSrc;

            if (this.mimetype === 'image/svg') {
                $image.classList.add('is--svg');
            }

            loadImage($image, (image) => {
                overlay.setContent(image);
                overlay.show();

                this.$imageZoom.classList.remove('is--loading');
                if (this.$loader) {
                    this.$loader.parentNode.removeChild(this.$loader);
                }

                if (this.mimetype.indexOf('application/pdf') === -1 && this.mimetype.indexOf('application/vnd') === -1) {
                    const distanceHorizontal = overlay.$overlayContent.offsetWidth - window.innerWidth;
                    const distanceVertical = overlay.$overlayContent.offsetHeight - window.innerHeight;

                    overlay.$overlayScroller.scrollLeft = 0.5 * distanceHorizontal;
                    overlay.$overlayScroller.scrollTop = 0.5 * distanceVertical;
                }
            });
        }
    }
}

export { ImageZoom };
